import { render, staticRenderFns } from "./RelbaseIssuanceDialog.vue?vue&type=template&id=1735245c&scoped=true&"
import script from "./RelbaseIssuanceDialog.vue?vue&type=script&lang=js&"
export * from "./RelbaseIssuanceDialog.vue?vue&type=script&lang=js&"
import style0 from "./RelbaseIssuanceDialog.vue?vue&type=style&index=0&id=1735245c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1735245c",
  null
  
)

export default component.exports